import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'hooks';
import { statuses } from './config';
import { styled } from '@mui/material/styles';

const Container = styled('div')(({ theme, $backgroundColor, $textColor }) => ({
  padding: '4px 8px',
  borderRadius: '4px',
  display: 'inline-block',
  backgroundColor: $backgroundColor || 'transparent',
  color: $textColor || '#000'
}));

function StatusText({ className = '', statusCode }) {
  const { t } = useTranslation();

  const { label, backgroundColor, textColor } = useMemo(() => {
    switch (statusCode) {
      case '200':
        return statuses.inProgress;
      case '300':
      case '320':
      case '340':
      case '350':
      case '380':
      case '1100':
      case '1120':
        return statuses.ongoing;
      case '400':
      case '500':
      case '600':
      case '700':
      case '800':
      case '1200':
      case '1300':
        return statuses.closed;
      default:
        return statuses.default;
    }
  }, [statusCode]);

  return (
    <Container className={className} $backgroundColor={backgroundColor} $textColor={textColor}>
      {t(label)}
    </Container>
  );
}

StatusText.propTypes = {
  className: PropTypes.string,
  statusCode: PropTypes.string
};

export default StatusText;
